<template>
  <NuxtLayout name="base">
    <template #navigation>
      <BaseNavigationBar
        :title="t('Назад')"
        :fallback-route="permissions.WORKSPACE.ROUTE"
      />
    </template>

    <div class="cookies-page">
      <!-- Legal Pages Navigation -->
      <nav class="legal-nav">
        <NuxtLink
          :to="permissions.LEGAL.PRIVACY.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.PRIVACY.ROUTE }"
        >
          Политика конфиденциальности
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.CONSENT.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.CONSENT.ROUTE }"
        >
          Согласие на обработку данных
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.COOKIES.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.COOKIES.ROUTE }"
        >
          Политика cookies
        </NuxtLink>
        <NuxtLink
          :to="permissions.LEGAL.ADVERTISING.ROUTE"
          class="legal-nav__item"
          :class="{ 'legal-nav__item--active': $route.path === permissions.LEGAL.ADVERTISING.ROUTE }"
        >
          Согласие на рекламу
        </NuxtLink>
      </nav>

      <h1 class="cookies-page__title">
        ПОЛИТИКА ИСПОЛЬЗОВАНИЯ COOKIE-ФАЙЛОВ
      </h1>

      <div class="cookies-page__intro">
        <p>Настоящая Политика использования cookie-файлов (далее - «Политика») описывает, как Общество с ограниченной ответственностью «Квест Проекты» (ОГРН 1247700644069, ИНН 9728142014, адрес: 117588, г. Москва, Новоясеневский пр-кт, д. 11, далее – «Оператор») использует cookie-файлы и аналогичные технологии на сайте <a href="https://prod.new.queststore.space" target="_blank">https://prod.new.queststore.space</a> (далее - «Сайт»).</p>
      </div>

      <section class="cookies-page__section">
        <h2>1. Что такое cookie-файлы</h2>
        <p>Cookie-файлы — это небольшие текстовые файлы, которые сохраняются на вашем устройстве (компьютере, планшете, смартфоне) при посещении веб-сайтов. Они широко используются для обеспечения работы веб-сайтов или повышения эффективности их работы, а также для предоставления информации владельцам сайта.</p>
      </section>

      <section class="cookies-page__section">
        <h2>2. Типы используемых cookie-файлов</h2>

        <h3>2.1. Необходимые cookie-файлы</h3>
        <p>Эти файлы необходимы для функционирования Сайта и не могут быть отключены в наших системах. Обычно они устанавливаются только в ответ на ваши действия, которые являются запросом на услуги, такие как:</p>
        <ul>
          <li>Установка настроек конфиденциальности</li>
          <li>Вход в систему</li>
          <li>Заполнение форм</li>
          <li>Сохранение языковых настроек</li>
        </ul>

        <h3>2.2. Аналитические cookie-файлы</h3>
        <p>Эти файлы позволяют нам подсчитывать посещения и источники трафика, чтобы мы могли измерять и улучшать производительность нашего Сайта. Они помогают нам узнать:</p>
        <ul>
          <li>Какие страницы наиболее и наименее популярны</li>
          <li>Как посетители перемещаются по Сайту</li>
          <li>Количество посетителей и время их пребывания на Сайте</li>
          <li>Источники трафика</li>
        </ul>

        <h3>2.3. Функциональные cookie-файлы</h3>
        <p>Эти файлы обеспечивают расширенную функциональность и персонализацию. Они могут устанавливаться нами или третьими сторонами, чьи услуги мы добавили на наши страницы. Они используются для:</p>
        <ul>
          <li>Запоминания ваших предпочтений</li>
          <li>Предоставления персонализированного контента</li>
          <li>Интеграции с социальными сетями</li>
          <li>Обеспечения безопасности</li>
        </ul>

        <h3>2.4. Маркетинговые cookie-файлы</h3>
        <p>Эти файлы могут устанавливаться на нашем Сайте нашими рекламными партнерами (только при вашем согласии). Они используются для:</p>
        <ul>
          <li>Создания профиля ваших интересов</li>
          <li>Показа релевантной рекламы на других сайтах</li>
          <li>Отслеживания эффективности рекламных кампаний</li>
        </ul>
      </section>

      <section class="cookies-page__section">
        <h2>3. Используемые нами cookie-файлы</h2>
        <div class="cookies-table">
          <table>
            <thead>
              <tr>
                <th>Название</th>
                <th>Тип</th>
                <th>Назначение</th>
                <th>Срок хранения</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>session_id</td>
                <td>Необходимые</td>
                <td>Идентификация пользовательской сессии</td>
                <td>До закрытия браузера</td>
              </tr>
              <tr>
                <td>auth_token</td>
                <td>Необходимые</td>
                <td>Авторизация пользователя</td>
                <td>30 дней</td>
              </tr>
              <tr>
                <td>lang_preference</td>
                <td>Функциональные</td>
                <td>Сохранение языковых настроек</td>
                <td>1 год</td>
              </tr>
              <tr>
                <td>_ga, _gid</td>
                <td>Аналитические</td>
                <td>Google Analytics</td>
                <td>2 года / 24 часа</td>
              </tr>
              <tr>
                <td>cookie_consent</td>
                <td>Необходимые</td>
                <td>Сохранение согласия на использование cookie</td>
                <td>1 год</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="cookies-page__section">
        <h2>4. Управление cookie-файлами</h2>
        <p>Вы можете управлять использованием cookie-файлов следующими способами:</p>

        <h3>4.1. Настройки браузера</h3>
        <p>Большинство веб-браузеров позволяют управлять cookie-файлами через настройки. Вы можете:</p>
        <ul>
          <li>Просматривать сохраненные cookie-файлы</li>
          <li>Удалять отдельные или все cookie-файлы</li>
          <li>Блокировать cookie-файлы от определенных сайтов</li>
          <li>Блокировать сторонние cookie-файлы</li>
          <li>Настроить автоматическое удаление cookie при закрытии браузера</li>
        </ul>

        <h3>4.2. Настройки на Сайте</h3>
        <p>На нашем Сайте вы можете управлять использованием необязательных cookie-файлов через панель настроек cookie, которая появляется при первом посещении Сайта.</p>
      </section>

      <section class="cookies-page__section">
        <h2>5. Влияние отключения cookie-файлов</h2>
        <p>Отключение cookie-файлов может повлиять на функциональность Сайта:</p>
        <ul>
          <li>Необходимые cookie: отключение приведет к нарушению работы основных функций Сайта</li>
          <li>Функциональные cookie: отключение может ухудшить пользовательский опыт</li>
          <li>Аналитические cookie: отключение не повлияет на функциональность, но поможет нам улучшать Сайт</li>
          <li>Маркетинговые cookie: отключение не повлияет на функциональность, но может сделать рекламу менее релевантной</li>
        </ul>
      </section>

      <section class="cookies-page__section">
        <h2>6. Сторонние cookie-файлы</h2>
        <p>Некоторые cookie-файлы устанавливаются третьими сторонами, чьи сервисы мы используем:</p>
        <ul>
          <li><strong>Google Analytics:</strong> для анализа использования Сайта</li>
          <li><strong>ЕСИА (Госуслуги):</strong> для авторизации через государственные услуги</li>
          <li><strong>Социальные сети:</strong> для интеграции кнопок социальных сетей</li>
        </ul>
        <p>Эти третьие стороны имеют собственные политики конфиденциальности и cookie.</p>
      </section>

      <section class="cookies-page__section">
        <h2>7. Согласие на использование cookie</h2>
        <p>Используя наш Сайт, вы соглашаетесь на использование необходимых cookie-файлов. Для использования других типов cookie-файлов мы запрашиваем ваше отдельное согласие.</p>
        <p>Вы можете изменить свои настройки cookie в любое время, обратившись к панели настроек cookie на Сайте или изменив настройки своего браузера.</p>
      </section>

      <section class="cookies-page__section">
        <h2>8. Контактная информация</h2>
        <p>Если у вас есть вопросы о нашем использовании cookie-файлов, пожалуйста, свяжитесь с нами по адресу электронной почты, указанному в нашей Политике конфиденциальности.</p>
      </section>

      <section class="cookies-page__section">
        <h2>9. Изменения в политике</h2>
        <p>Мы можем периодически обновлять эту Политику использования cookie-файлов. Актуальная версия всегда доступна по адресу: <a href="https://prod.new.queststore.space/legal/cookies" target="_blank">https://prod.new.queststore.space/legal/cookies</a></p>
      </section>

      <div class="cookies-page__footer">
        <p class="cookies-page__date">
          Дата последнего обновления: {{ new Date().toLocaleDateString('ru-RU') }}
        </p>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { permissions } from '~/shared/lib'
import { BaseNavigationBar } from '~/shared/ui'

import i18n from '../model/CookiesPage.i18n.json'

const { t } = useI18n(i18n)

definePageMeta({
  layout: 'base',
})
</script>

<style scoped lang="scss">
.legal-nav {
  display: flex;
  flex-wrap: wrap;
  gap: rem(8px);
  margin-bottom: rem(32px);
  padding: rem(16px);
  background-color: #f8f9fa;
  border-radius: rem(8px);
  border: 1px solid #e9ecef;

  &__item {
    padding: rem(8px) rem(16px);
    border-radius: rem(20px);
    border: 1px solid #dee2e6;
    background-color: #fff;
    color: #6c757d;
    text-decoration: none;
    font-size: rem(14px);
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease;

    &:hover {
      background-color: #e9ecef;
      border-color: #adb5bd;
    }

    &--active {
      background-color: #007bff;
      color: #fff !important;
      border-color: #007bff;

      &:hover {
        background-color: #0056b3;
        border-color: #0056b3;
      }
    }
  }
}

@media (width <= 768px) {
  .legal-nav {
    padding: rem(12px);
    gap: rem(6px);

    &__item {
      padding: rem(6px) rem(12px);
      font-size: rem(12px);
    }
  }
}

.cookies-page {
  max-width: rem(800px);
  margin: 0 auto;
  padding: rem(48px);
  background-color: #fff;
  border-radius: rem(8px);

  &__title {
    font-size: rem(32px);
    font-weight: 700;
    margin-bottom: rem(16px);
    color: #1a1a1a;
  }

  // Common link styles
  a {
    color: #06c;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__intro {
    margin-bottom: rem(32px);

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
    }
  }

  &__section {
    margin-bottom: rem(40px);

    h2 {
      font-size: rem(24px);
      font-weight: 600;
      margin-bottom: rem(16px);
      color: #1a1a1a;
    }

    h3 {
      font-size: rem(18px);
      font-weight: 600;
      margin-top: rem(24px);
      margin-bottom: rem(12px);
      color: #2c2c2c;
    }

    p {
      font-size: rem(16px);
      line-height: 1.6;
      color: #333;
      margin-bottom: rem(12px);
    }

    ul {
      list-style-type: disc;
      margin-left: rem(24px);
      margin-bottom: rem(16px);

      li {
        font-size: rem(16px);
        line-height: 1.6;
        color: #333;
        margin-bottom: rem(8px);

        strong {
          font-weight: 600;
        }
      }
    }
  }

  .cookies-table {
    overflow-x: auto;
    margin: rem(16px) 0;

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: rem(14px);

      th,
      td {
        padding: rem(12px);
        text-align: left;
        border: 1px solid #e0e0e0;
      }

      th {
        background-color: #f5f5f5;
        font-weight: 600;
        color: #1a1a1a;
      }

      td {
        color: #333;
      }

      tr:nth-child(even) {
        background-color: #fafafa;
      }
    }
  }

  &__footer {
    margin-top: rem(48px);
    padding-top: rem(24px);
    border-top: 1px solid #e0e0e0;
  }

  &__date {
    font-size: rem(14px);
    color: #666;
    text-align: center;
  }
}

@media (width <= 768px) {
  .cookies-page {
    padding: rem(32px) rem(24px);

    &__title {
      font-size: rem(24px);
    }

    &__section {
      h2 {
        font-size: rem(20px);
      }

      h3 {
        font-size: rem(16px);
      }
    }

    .cookies-table {
      table {
        font-size: rem(12px);

        th,
        td {
          padding: rem(8px);
        }
      }
    }
  }
}
</style>
